export default function EmptyState() {
  return (
    <div className="w-full flex items-center justify-center py-6">
      <p className="text-sm text-muted-foreground">
        Bu spesifikasyon için henüz ürün yanıtı bulunmuyor.
      </p>
    </div>
  );
}

